var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('TheNavBar',{staticClass:"d-inline-block elevation-12"}),_c('v-content',[_c('router-view')],1),_c('TheFooter'),_c('ErrorSnackBar'),_c('SuccessSnackBar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }